import { render, staticRenderFns } from "./Home.data-manager-stags-versions-edit.vue?vue&type=template&id=d5805914&scoped=true&"
import script from "./Home.data-manager-stags-versions-edit.vue?vue&type=script&lang=js&"
export * from "./Home.data-manager-stags-versions-edit.vue?vue&type=script&lang=js&"
import style0 from "./Home.data-manager-stags-versions-edit.vue?vue&type=style&index=0&id=d5805914&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5805914",
  null
  
)

export default component.exports